function MikkellerBaghavenLogo() {
  return (
    <img
      height="180"
      width="140"
      src="/logos/baghaven-logo.png"
      className="w-full h-full object-contain"
      alt="Mikkeller Baghaven"
      loading="eager"
      decoding="async"
    />
  );
}

export { MikkellerBaghavenLogo };
